import { atom } from 'jotai';

export const commentPanelOpenAtom = atom(false);

export const pendingCommentEntityIdAtom = atom<string | null>(null);
